import { render, staticRenderFns } from "./NavScroll.vue?vue&type=template&id=497ab5c2&"
import script from "./NavScroll.vue?vue&type=script&lang=js&"
export * from "./NavScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports